import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CalcType, KeyValue, WebformService } from '@app/services/webform.service';
import { mobiIcon } from '@mobi/rwc-utils-icons-jslib';
import { Subscription } from 'rxjs';

export type CardEntry = {
  icon: mobiIcon;
  label: string;
  text?: string;
};
@Component({
  standalone: false,
  selector: 'webform-summary-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit, OnDestroy {
  @Input() isCalculator: boolean = false;
  @Input() action: Function | null = null;
  @Input() plugin?: CalcType;
  @Input() title?: string;
  @Input() entries: CardEntry[] = [];

  calculatorElement?: KeyValue;

  #calculatorElementSub!: Subscription;

  readonly #webform = inject(WebformService);
  readonly #cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    if (!this.isCalculator) return;
    this.#calculatorElementSub = this.#webform.calculatorElement.subscribe(
      (e: KeyValue) => {
        this.calculatorElement = e;
        this.#cdr.markForCheck();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.#calculatorElementSub) this.#calculatorElementSub.unsubscribe();
  }

  get isDealer(): boolean {
    return (
      this.#webform.formId.includes('haendler') || this.#webform.formId.includes('dealer')
    );
  }
}
